$(document).ready(function () {
  var time = 2;
  var $bar, $slick, isPause, tick, percentTime; // adding "0" to single number

  function n(n) {
    return n > 9 ? "" + n : "0" + n;
  }

  var slider = $('.slider-component');
  var jQuerystatusFirst = $('.pagingInfo .counter--top');
  var jQuerystatusLast = $('.pagingInfo .counter--bottom');
  slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    jQuerystatusFirst.text('0' + i);
    jQuerystatusLast.text('0' + slick.slideCount);
  }); // slider.on('init', function (event, slick, currentSlide, nextSlide) {
  //     let sliderHeight = slider.outerHeight();
  //     $(this).find('.slick-slide').each(function(){
  //         let imgHeight =  $(this).find('.top_slider__info').next().height();
  //         $(this).find('.top_slider__info').height(sliderHeight - imgHeight - 60);
  //     })
  // });

  slider.slick({
    infinite: true,
    dots: true,
    arrows: true,
    autoplay: false,
    fade: true,
    cssEase: 'ease-out',
    speed: 1000,
    useTransform: true,
    adaptiveHeight: false,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    // swipe: false,
    // swipeToSlide: false,
    pauseOnHover: true,
    responsive: [{
      breakpoint: 1025,
      settings: {
        fade: false,
        cssEase: 'ease',
        speed: 350
      }
    }]
  });
  $bar = $('#image-seekbar span');

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 30);
  }

  function interval() {
    if (isPause === false) {
      percentTime += 1 / (time + 0.1);
      $bar.css({
        width: percentTime + "%"
      });

      if (percentTime >= 100) {
        slider.slick('slickNext');
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $bar.css({
      width: 0 + '%'
    });
    clearTimeout(tick);
  }

  startProgressbar();
  $('.custom-controls .next, .custom-controls .prev').click(function () {
    startProgressbar();
  }); // slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
  // startProgressbar();
  // });

  var isTouchDevice = ('ontouchstart' in document.documentElement);

  if (isTouchDevice) {
    var sliderFirstClick = function sliderFirstClick() {
      isPause = true;
    };

    var sliderSecondClick = function sliderSecondClick() {
      isPause = false;
    }; // slider.not('.btn').click(function () {
    //     return (this.tog = !this.tog) ? sliderFirstClick() : sliderSecondClick();
    // });


    $(document.body).on('click', '.top_slider__info', function (e) {
      if (e.target.tagName === 'A') return; // not the element we want

      return (this.tog = !this.tog) ? sliderFirstClick() : sliderSecondClick();
    });
  } else {
    slider.find('.top_slider__info').mouseover(function () {
      isPause = true;
    });
    slider.find('.top_slider__info').mouseleave(function () {
      isPause = false;
    });
  }

  $('.youtube-wrap .play, .iframe-wrap .play, .video-wrap .play').on('click', function () {
    $(this).fadeOut();
    $(this).siblings('.preview').fadeOut();
    $(this).siblings('video').trigger('play');
  });
  $('.youtube-wrap video, .iframe-wrap video, .video-wrap video').on('ended', function () {
    $(this).siblings('.play').fadeIn();
    $(this).siblings('.preview').fadeIn();
  });
});